// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import find from 'lodash/find'
import { updateCustomField } from 'utils/proposals'
import { LIVE_CHAT_AVAILABILITY } from 'constants/proposalFieldTypes'

// Atoms
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import FieldLayout from '../FieldLayout'


export default class LiveChatAwayMessageEditor extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    normalizedFields: PropTypes.array.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
  }

  getSchedule() {
    const { normalizedFields } = this.props
    const { value = [] } = find(normalizedFields, { type: LIVE_CHAT_AVAILABILITY }) || {}
    return value
  }

  hasAvailability = () => {
    const schedule = this.getSchedule()
    return !!schedule.length
  }

  handleSave = (value) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, { value })
      }
    })
  }

  render() {
    if (!this.hasAvailability()) return null
    const { field } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Away">
          <TextInput
            required
            maxLength={500}
            multiline
            placeholder="Type an away message here..."
            defaultValue={field.value || ''}
            onSave={this.handleSave}
          />
        </FieldLayout>
      </Fragment>
    )
  }
}
